// extracted by mini-css-extract-plugin
module.exports = {"account":"styles_account__jJaRV","left":"styles_left__23bM_","logout":"styles_logout__3YLh2","name":"styles_name__2B3AF","role":"styles_role__EJlxQ"};